import { BREAKPOINTS } from '../constants/breakpoints.mjs';
import { keys, camelToKebabCase } from './helpers.mjs';
import { sortMediaQueries } from './mediaQuery.mjs';
import { resolvers } from './resolvers.mjs';

function stylesToString({ selector, styles, media }) {
  const baseStyles = styles ? cssObjectToString(styles) : "";
  const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item) => `@media ${item.query}{${selector}{${cssObjectToString(item.styles)}}}`);
  return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}`.trim();
}
function cssObjectToString(css) {
  return keys(css).reduce((acc, rule) => css[rule] !== void 0 ? `${acc}${camelToKebabCase(rule)}:${css[rule]};` : acc, "").trim();
}
function hasResponsiveStyles(styleProp) {
  if (typeof styleProp !== "object" || styleProp === null) {
    return false;
  }
  const breakpoints = Object.keys(styleProp);
  if (breakpoints.length === 1 && breakpoints[0] === "base") {
    return false;
  }
  return true;
}
function getBaseValue(value) {
  if (typeof value === "object" && value !== null) {
    if ("base" in value) {
      return value.base;
    }
    return void 0;
  }
  return value;
}
function getBreakpointKeys(value) {
  if (typeof value === "object" && value !== null) {
    return keys(value).filter((key) => key !== "base");
  }
  return [];
}
function getBreakpointValue(value, breakpoint) {
  if (typeof value === "object" && value !== null && breakpoint in value) {
    return value[breakpoint];
  }
  return value;
}
function parseStyleProps({ styleProps, data }) {
  return sortMediaQueries(
    keys(styleProps).reduce(
      (acc, styleProp) => {
        const propertyData = data[styleProp];
        const properties = Array.isArray(propertyData.property) ? propertyData.property : [propertyData.property];
        const baseValue = getBaseValue(styleProps[styleProp]);
        if (!hasResponsiveStyles(styleProps[styleProp])) {
          properties.forEach((property) => {
            acc.inlineStyles[property] = resolvers[propertyData.type](baseValue);
          });
          return acc;
        }
        acc.hasResponsiveStyles = true;
        const breakpoints = getBreakpointKeys(styleProps[styleProp]);
        if (baseValue !== void 0) {
          acc.styles[styleProp] = baseValue;
        }
        properties.forEach((property) => {
          if (baseValue) {
            acc.styles[property] = resolvers[propertyData.type](baseValue);
          }
          breakpoints.forEach((breakpoint) => {
            const bp = `(width < ${BREAKPOINTS[breakpoint]}px)`;
            acc.media[bp] = {
              ...acc.media[bp],
              [property]: resolvers[propertyData.type](getBreakpointValue(styleProps[styleProp], breakpoint))
            };
          });
        });
        return acc;
      },
      {
        hasResponsiveStyles: false,
        inlineStyles: {},
        styles: {},
        media: {}
      }
    )
  );
}

export { cssObjectToString, getBaseValue, getBreakpointKeys, getBreakpointValue, hasResponsiveStyles, parseStyleProps, stylesToString };
